<template>
  <div class="AboutUs">
    <div class="AboutUs_body">
      <div class="top">
        <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">
          <i class="el-icon-s-home" />首页
        </el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/aboutUs' }">
          关于我们
        </el-breadcrumb-item>
      </el-breadcrumb>
      </div>
      <div class="header">
        <div class="header_blue">
          <div
            class="header_white_warrper"
            v-for="(item, index) in list"
            :key="index"
            @click="add(index)"
            :class="indexcopy == index ? 'header_blue_warrper' : ''"
          >
            {{ item.text }}
          </div>
        </div>
      </div>
      <div v-show="listActive">
        <div class="header_font">国家技术转移郑州中心</div>
        <div class="header_xiao">
          国家技术转移郑州中心是继北京中关村之后，国家批复的第二个区域性技术转移中心。在此方面有着区位、交通、人才三大优势。
        </div>
        <div class="div_content_img">
          <img class="div_content_img_css" src="../assets/images/关于1.jpg" />
        </div>
        <p class="div_p">简介</p>
        <div class="div_fontSize">
          国家科技部正式批复，同意国家技术转移郑州中心建设发展规划，支持河南省在中部地区先行先试，集聚、整合和利用国内外创新资源，形成以国家技术转移郑州中心为枢纽的跨区域、跨领域、跨机构的技术流通与转化新格局。据悉，国家技术转移郑州中心是继中关村技术转移集聚区之后，国家批复的第二个区域性技术转移中心。<br /><br />
          国家技术转移郑州中心网（以下简称“网络平台”）面向专家、个人、机构、企业等对象，旨在促进技术成果转移、提升技术转化率，提高企业的科技创新能力。网络平台承载着的项目管理、发布、对接、交易等重要功能，为各大企业、高校、科研机构等开展技术转移架设桥梁，承担中介角色。平台以知识产权为中心，与国内外的技术转移机构、科技企业和高等院校等组织对接。网站将与70多个网站，100多个国际技术转移机构，300多所高校和科研院所建立全球技术合作关系，逐步建成科技服务大市场，成为河南省技术转移成果转化门户网站，为河南省技术转移成果转化提供全方位服务。
        </div>
        <div class="div_content_img2">
          <img
            class="div_content_img_css2"
            src="../assets/images/关于2.jpg"
            alt=""
          />
        </div>
        <p class="div_p">作用</p>
        <div class="div_fontSize">
          国家技术转移郑州中心网（以下简称“网络平台”）面向专家、个人、机构、企业等对象，旨在促进技术成果转移、提升技术转化率，提高企业的科技创新能力。网络平台承载着的项目管理、发布、对接、交易等重要功能，为各大企业、高校、科研机构等开展技术转移架设桥梁，承担中介角色。平台以知识产权为中心，与国内外的技术转移机构、科技企业和高等院校等组织对接。网站将与70多个网站，100多个国际技术转移机构，300多所高校和科研院所建立全球技术合作关系，逐步建成科技服务大市场，成为河南省技术转移成果转化门户网站，为河南省技术转移成果转化提供全方位服务。<br /><br />
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;国家技术转移郑州中心将充分利用国内外先进技术，培育科技型中小企业和新的经济增长点，建立技术创新市场导向机制，健全技术交易、成果展示与转化、人才引进及创业孵化、知识产权服务、各类科技创新公共服务等创新服务功能，引领相关行业领域迅速发展，打通科技与经济社会发展之间的通道，全面提升我省科技创新服务经济社会发展的能力。<br /><br />
          整个网络平台涵盖国际技术转移服务平台、全省产业集聚区技术转移服务平台、创新成果展示和发布平台、科技资源共享服务平台、科技综合服务平台、技术交易服务平台、科技金融服务平台、新兴产业研发服务平台等八大平台业务内容，并围绕中心的技术转移服务、技术交易、技术研发服务三大部分的核心业务进行规划和设计。同时通过综合运营管理平台保障网络支撑平台的有效运营。
        </div>
        <div class="div_content_img3">
          <img
            class="div_content_img_css3"
            src="../assets/images/关于3.png"
            alt=""
          />
        </div>
        <p class="div_p">位置</p>
        <div class="div_fontSize div_fontSizebottom">
          位于郑州市郑东新区龙子湖湖心岛崇德街与明理路交叉口西南角，主要建设内容包括技术转移服务中心区、技术产权交易区和高端制造技术研发区三大功能区，构建技术交易、科技资源共享、科技成果转化服务、新兴产业研发、创新成果展示等公共服务平台及附属配套设施。建设用地33.8亩，规划总建筑面积168350平方米，总投资8.99亿元。
        </div>
      </div>
      <div v-show="listActiveCopy">
        <div>
          <br /><br /><br />
          <h3 style="">中心概况</h3>
          <br /><br />
          <p>
            <span
              >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;河南省生产力促进中心成立于1993年8月，1995年12月经河南省编办批准为事业法人，是面向社会提供科技服务的河南省科学技术厅直属公益二类事业单位。1997年被国家科委评为首批十家国家级示范生产力促进中心之一、2002年通过ISO质量管理体系认证，并先后被评为国家级国际科技合作基地、“金桥奖”、“生产力促进奖”以及国家和省级先进集体等。</span
            >
          </p>
          <br /><br />
          <p>
            <span
              >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;河南省生产力促进中心成立于1993年8月，1995年12月经河南省编办批准为事业法人，是面向社会提供科技服务的河南省科学技术厅直属公益二类事业单位。1997年被国家科委评为首批十家国家级示范生产力促进中心之一、2002年通过ISO质量管理体系认证，并先后被评为国家级国际科技合作基地、“金桥奖”、“生产力促进奖”以及国家和省级先进集体等。</span
            >
          </p>
          <br /><br /><br />
          <h3>科技创新</h3>
          <br /><br />
          <p>
            <span
              >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;多年来，中心始终以“聚一流人才，联万家企业，促生产力发展”的宗旨和“以人为本，诚信立业，追求卓越”的文化为标杆，围绕现代服务业逐渐形成“资金、技术（人才）、载体”三位一体的服务模式，走出了一条以技术转移、科技孵化、科技金融为核心，以科技咨询与评估、产业集群服务、创新产品设计、人才测评与培训为基础的服务业态方式，为省内外政府、企业提供了优质高效的咨询服务，获得了合作单位、服务客户的认可与好评。</span
            >
          </p>
          <br /><br />
          <p>
            <span
              >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;先后在新乡、洛阳和林州等地，建设了863孵化器，初步形成了“863孵化器”在河南省的网络化布局并与100多家科研单位、高等院校、境外生产力促进机构建立了密切的合作关系，与400多位专家保持着经常性的联系，这些专家来自科研院所、大学、企业、行业管理部门等单位，具有高级以上职称，所学专业及擅长的学科领域涵盖了我省国民经济和科技事业的绝大部分行业，是目前河南省最大的综合性、专业化科技服务机构。</span
            >
          </p>
          <br /><br />
          <h3>主要业务</h3>
          <br /><br />
          <h3>技术转移服务</h3>
          <br /><br />
          <p>
            <span
              >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;服务内容：协助承担国家技术转移郑州中心服务运营工作；负责国家技术转移郑州中心云服务平台建设运营推广工作；结合需求提供区域技术转移中心（平台）建设运营服务；提供技术成果（项目）代理推广、需求（项目）代理对接等技术供需交易服务；提供成果和需求评估评价服务；开展国内外技术成果项目对接交流活动；开展技术转移专业人员培训服务等。</span
            >
          </p>
          <br /><br />
          <p>
            <span
              >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;联系电话：0371-67579156
              0371-67579136</span
            >
          </p>
          <br /><br />
          <h3>科技孵化与科技金融服务</h3>
          <p>
            <span
              >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;联系电话：0371-67579127
              0371-67579127</span
            >
          </p>
          <br /><br />
          <h3>科技咨询与评估服务</h3>
          <br /><br />
          <p>
            <span
              >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;服务内容：面向各级科技部门提供项目评审、人才评价、机构评估等科技评估服务；面向各级政府部门提供财政支出绩效评价服务；面向企业提供研发费用加计扣除、高新技术企业认定咨询及申报服务。</span
            >
          </p>
          <br /><br />
          <p>
            <span
              >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 联系电话：0371-67579130
              0371-67579135</span
            >
          </p>
          <br /><br />
          <h3>创新培训服务</h3>
          <br /><br />
          <p>
            <span
              >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              服务内容：面向高校学生和社会人员开展VR/AR应用开发、人工智能python等技能培训；结合需求开展创新游学、产品创新与管理创新人才培训等。</span
            >
          </p>
          <br /><br />
          <p>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 联系电话：13949002730 </span>
          </p>
          <br /><br />
          <p>
            <span
              >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              联系地址：河南省郑州市高新区翠竹街6号1号楼A座4楼
            </span>
          </p>
          <br /><br />
          <p>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 联系电话：0371-67579808 </span>
          </p>
          <br /><br />
          <p>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 工作邮箱：hnppc@163.com</span>
          </p>
          <br /><br /><br /><br />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      listActive: true,
      listActiveCopy: false,
      indexcopy: 0,
      list: [
        {
          text: "国家技术转移郑州中心",
          id: 1,
        },
        {
          text: "河南省生产力促进中心",
          id: 2,
        },
      ],
    };
  },
  methods: {
    add(index) {
      this.indexcopy = index;
      if (index == 0) {
        this.listActive = true;
        this.listActiveCopy = false;
      } else if (index == 1) {
        this.listActive = false;
        this.listActiveCopy = true;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.AboutUs {
  width: 100%;
  margin: 0rem;
  padding: 0rem;
  text-align: left !important;
  display: flex;
  justify-content: center;
  .AboutUs_body {
    width: 80%;
    .top {
    margin-top: 25px;
     width: 100%;
    }
    .header {
      margin-top: 2.5rem;
      display: flex;
      .header_blue {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 46px;
        opacity: 1;
        .header_blue_warrper {
          margin: 0px 10px;
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 13.75rem;
          height: 2.875rem;
          color: white;
          background: #2769dc;
          opacity: 1;
          border-radius: 0rem;
        }
        .header_blue_warrper::after {
          position: absolute;
          left: 0;
          right: 0;
          margin: auto;
          bottom: -8px;
          content: "";
          width: 9px;
          height: 7px;
          box-sizing: border-box;
          border-top: 9px solid #0561d2;
          border-left: 7px solid transparent;
          pointer-events: none;
          border-right: 7px solid transparent;
        }
        // #switchover {
        //   position: absolute;
        //   left: 0;
        //   right: 0;
        //   margin: auto;
        //   bottom: -0.5rem;
        //   content: "";
        //   width: 0.5625rem;
        //   height: 0.4375rem;
        //   box-sizing: border-box;
        //   border-top: 0.5625rem solid #0561d2;
        //   border-left: 0.4375rem solid transparent;
        //   pointer-events: none;
        //   border-right: 0.4375rem solid transparent;
        // }
      }
      .header_white {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 46px;
        background: #ffffff;
        opacity: 0.4;
        border-radius: 0rem;
        .header_white_warrper {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 200px;
          height: 25px;
          font-size: 18px;
          font-family: PingFang SC;
          font-weight: 400;
          line-height: 1.625rem;
          color: #333333;
          opacity: 1;
        }
      }
    }
    .header_font {
      margin-top: 2.5rem;
      width: 20rem;
      height: 2.625rem;
      font-size: 2rem;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #333333;
      opacity: 1;
    }
    .header_xiao {
      margin-top: 1.5625rem;
      width: 84.75rem;
      height: 2.4375rem;
      font-size: 1.125rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 2rem;
      color: #4a4a4a;
      opacity: 1;
    }
    .div_content_img {
      margin-top: 1.5rem;
      width: 100%;
      display: flex;
      justify-content: center;
      .div_content_img_css {
        width: 41.6875rem;
        height: 29.375rem;
        opacity: 1;
        border-radius: 0rem;
      }
    }
    .div_p {
      margin-top: 2.5rem;
      width: 3.25rem;
      height: 2.1875rem;
      font-size: 1.625rem;
      font-family: Microsoft YaHei;
      font-weight: bold;
      line-height: 0rem;
      color: #333333;
      opacity: 1;
    }
    .div_fontSize {
      width: 87.5rem;
      font-size: 1.125rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 2rem;
      color: #4a4a4a;
      opacity: 1;
    }
    .div_content_img2 {
      margin-top: 2.125rem;
      width: 100%;
      display: flex;
      justify-content: center;
      .div_content_img_css2 {
        width: 48.5625rem;
        height: 28.125rem;
        opacity: 1;
        border-radius: 0rem;
      }
    }
    .div_content_img3 {
      margin-top: 2.125rem;
      width: 100%;
      display: flex;
      justify-content: center;
      .div_content_img_css3 {
        width: 46.8125rem;
        height: 31.8125rem;
        opacity: 1;
        border-radius: 0rem;
      }
    }
    .div_fontSizebottom {
      margin-bottom: 3.5625rem;
    }
  }
}
</style>
